<template>
  <div>
    <h3 style="margin: 30px; text-align: center; color: #333; font-size: 16px">身份认证中。。。。</h3>
  </div>
</template>

<script>
export default {
  /**
   * 组件
   */
  components: {},
  /**
   * 数字
   */
  data() {
    return {};
  },
  /**
   * 监听Vue实例上的数据变动
   */
  watch: {},

  /**
   * 方法、函数
   */
  methods: {},
  /**
   * 完成挂载
   */
  mounted() {},
  /**
   * 更新完成状态
   */
  updated: function() {},
  destroyed() {},
  /**
   * 完成了 data 数据的初始化
   */
  async created() {
    let projectid = this.$route.query.projectid || 0;
    let userInfo = await this.http.get("/user/getloginuserinfo");
    if (userInfo && userInfo.category == 4)
      this.$router.push("/referee/list?projectid=" + projectid);
    else {
      let menuRes = await this.http.get("/menu/getmenulist");
      if (menuRes && menuRes.length > 0) {
        this.$router.push(menuRes[0].child[0].url);
      }
    }
  }
};
</script>
<style scoped>
.router-child-container {
  background-color: transparent;
  padding: 0px;
  width: 100%;
  margin-top: -20px;
}
</style>



// WEBPACK FOOTER //
// src/view/main.vue